import { z } from 'zod';
const getMissionDirectoryParamsSchema = z.object({
    missionId: z.string().uuid(),
});
const getMissionDirectoryResponseSchema = z.object({
    exists: z.boolean(),
    fileId: z.string(),
    file: z.any(),
    directory: z.boolean(),
    wasCreated: z.boolean(),
});
export const getMissionDirectoryFunctionDef = {
    name: 'getMissionDirectory',
    requestSchema: getMissionDirectoryParamsSchema,
    responseSchema: getMissionDirectoryResponseSchema,
};
